import {useNavigate} from 'react-router-dom';
import {Button} from '@vidazoo/ui-kit';
import UrlsService from '../../../../common/router/services/urlsService.mdl';
import {ReactComponent as CalendarIcon} from '../assets/calendar.svg';
import {ReactComponent as PlusIcon} from '../../../charts/list/assets/plus-small.svg';
import theme from '../view/theme.module.scss';

export default function ScheduleReportsHeader() {
    const navigate = useNavigate();
    return <div className={theme.header}>
        <h1 className={theme.title}><CalendarIcon className={theme.titleIcon} aria-hidden="true"/>Schedule Reports</h1>
        <Button type="button" blue medium className={theme.create}
            iconName={<PlusIcon className={theme.plusIcon} aria-hidden="true"/>}
            onClick={() => navigate(UrlsService.createScheduleReport())}>Create Schedule Report</Button>
    </div>;
}
